/**
 * Helper partagé : retourne la liste des tailles dispos pour un produit boutique IPHB.
 * - Si le produit a un champ `sizes` (array) renseigné côté backend → utilisé tel quel.
 * - Sinon inféré depuis `category` / `group` / `name` :
 *     • Accessoires (écharpes, mugs…) → null (pas de taille demandée)
 *     • Maillots / vêtements Enfants → 8/10/12/14/16 ans
 *     • Maillots / vêtements Adultes → S/M/L/XL/XXL
 */
export function getProductSizes(p) {
  if (!p) return null;
  if (Array.isArray(p.sizes) && p.sizes.length > 0) return p.sizes;
  const grp = (p.group || "").toLowerCase();
  if (grp === "cadeaux-et-accessoires") return null;
  const name = (p.name || "").toLowerCase();
  const isKid = /enfant|enfants|kid/.test(name);
  if (isKid) return ["8 ans", "10 ans", "12 ans", "14 ans", "16 ans"];
  return ["S", "M", "L", "XL", "XXL"];
}
